import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";

import numberFormatter from "utils/numberFormatter";

import KPIComparator from "components/visuals/KPIComparator";

import { useAppSelector } from "store";
import { selectStore, selectComparator } from "modules/customer/insights/portfolio/portfolioSlice";
import { selectors } from "modules/customer/insights/portfolio/profit/grossProfitMargin";

const GrossProfitLastYear = () => {
    const selectedStore = useAppSelector(selectStore);
    const selectedComparator = useAppSelector(selectComparator);
    const grossProfitLastYear = useSelector(state => selectors.grossProfitLastYear(state));
    const { loading, error, value, percentageDifference } = grossProfitLastYear;
    const label = `${selectedStore.name} Gross Profit over past 12 months vs the ${selectedComparator.name}`;
    const valueFormatted = numberFormatter.toGBP(value, 1);

    return (
        <Box width="100%" height="100%" data-cy="gross-profit-last-year">
            <KPIComparator loading={loading} error={error} label={label} value={valueFormatted} percentage={percentageDifference} />
        </Box>
    );
};

export default GrossProfitLastYear;
